import rawRequest from '@/CommonDP/utils/request';
function addprefix(url) {
  return `${url.charAt(0) === '/' ? '' : '/'}${url}`;
}

function formatParams(url, ...rest) {
  url = addprefix(url);
  return [url, ...rest];
}

function request(url, ...rest) {
  rest = formatParams(url, ...rest);
  return rawRequest(...rest);
}

request.get = function(url, ...rest) {
  rest = formatParams(url, ...rest);
  return rawRequest.get(...rest);
};

request.post = function(url, ...rest) {
  rest = formatParams(url, ...rest);
  return rawRequest.post(...rest);
};
export default request;
